import { Navigate } from "react-router-dom"
import { useGlobal } from "@/app/store/global"

export const useNavigateIfNotAuthorized = () => {
  const isAuthorized = useGlobal(useGlobal.selectAuthState)
  if (!isAuthorized) return <Navigate to="/auth/login/" />
}
